import React, { useCallback } from 'react';
import c from 'classnames';
import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useTranslation } from 'react-i18next';

import { SearchFacets, SearchFacetRefinementCheckboxes } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import './style.scss';

const SearchForumFacets: React.FC<SearchFacetsProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.facets' });

  const classes = c('SearchForum__Facets', className);

  const transformItems = useCallback((items: RefinementListItem[]) => items.map((item) => ({
    ...item,
    label: t(`entity_type.${item.value}`),
    count: null,

    // We only want to transform these items on mount, to prevent unnecessary rerenders.
    // However, linting wants to force us to add "t" as a dependency. That's why we disable it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  })), []);

  return (
    <SearchFacets {...restProps} className={classes}>
      <SearchFacetRefinementCheckboxes
        attribute="entity_type"
        className="Checkboxes--unframed"
        transformItems={transformItems}
        sortBy={['name:desc']}
      />
    </SearchFacets>
  );
};

export default SearchForumFacets;
